import { FullPageContainer } from '../../common/components/GroveContainers';
import { AllMembershipsGrid } from '../../entities/membership/components/MembershipsList';

export const GenericHome = () => {
    // No specs for this view yet, so just return the memberships list for now
    return (
        <FullPageContainer>
            <AllMembershipsGrid />
        </FullPageContainer>
    );
};
